import { fetchBackend } from '@/utils/fetch'
import { OpsNoteCreateRequest } from './OpsNoteCreateRequest'
import { ServiceResponse } from 'loca-boot-core'

// https://apidoc.nioint.com/project/8100/interface/api/818390
// 记录全局复制日志
export function createOperationNotes(request: OpsNoteCreateRequest) {
  const result = fetchBackend.post('/pe/powerpro/v1/logs/global-copy-save', {
    params: request.getSerializableObject()
  })
  return result
}

// 获取配置信息
export async function getCopyLengthLimit(type: string) {
  const res = await fetchBackend.post<any>('/pe/powerpro/node/api/v1/resources/component/config', {
    params: { type }
  })
  return res
}
